import React from 'react';
// ANTD
import Input from 'antd/lib/input';
import Form from 'antd/lib/form';

const FormItem = Form.Item;
const { TextArea } = Input;
class EmailTemplateForm extends React.PureComponent {
  render() {
    return (
      <div>
        <div>
          <label>Template Title</label>
          <Input
            size="large"
            style={{ marginBottom: 5 }}
            value={this.props.title}
            onChange={e => this.props.onChange({ title: e.target.value })}
          />
        </div>
        <div label="Subject Line">
          <label>Subject Line</label>
          <Input
            size="large"
            style={{ marginBottom: 5 }}
            value={this.props.subject}
            onChange={e => this.props.onChange({ subject: e.target.value })}
          />
        </div>
        <div>
          <label>Body</label>
          <TextArea
            size="large"
            style={{ marginBottom: 5 }}
            value={this.props.body}
            onChange={e => this.props.onChange({ body: e.target.value })}
          />
        </div>
      </div>
    );
  }
}

export default EmailTemplateForm;



// WEBPACK FOOTER //
// ./src/components/forms/EmailTemplateForm/index.js